import {
  GetManageImagesStyleDataPayload,
  ManageImagesStyleColor,
  ManageImagesStyleImage,
  UnmatchedUpload,
} from '__generated__/atlas-types'

export type Style = GetManageImagesStyleDataPayload | null

export type ProductImage = Partial<Omit<ManageImagesStyleImage, 'orderNbr'>> &
  Pick<UnmatchedUpload, 'unmatchedUploadId'>

export type StyleColor = Partial<ManageImagesStyleColor> &
  Pick<UnmatchedUpload, 'unmatchedUploadId'>

// File error codes from react-dropzone FileError type
export enum FILE_ERROR_CODES {
  INVALID = 'file-invalid-type',
  TOO_LARGE = 'file-too-large',
  TOO_MANY = 'too-many-files',
}
